import { z } from 'zod';

const example = z.object({
  reference: z.string(),
  project_name: z.string().nullable(),
  period_summary: z.string(),
  started_at: z.string().optional(),
  /** Past assignments carry their own session's title and folder. */
  session_context: z.record(z.string(), z.string()).optional(),
});
export const projectSuggestionSchema = z.object({
  status: z.enum(['predicted', 'abstained', 'refusal']),
  project_id: z.number().nullable(),
  project_name: z.string().nullable(),
  probability: z.number().optional(),
  candidates: z
    .array(
      z.object({
        project_id: z.number(),
        project_name: z.string(),
        probability: z.number().min(0).max(1),
      })
    )
    .optional(),
  fingerprint: z.string(),
  generated_at: z.string(),
  evidence: z
    .object({
      period_summary: z.string(),
      session_context: z.record(z.string(), z.string()),
      prior_session_periods: z.array(example),
      assignment_history: z.array(example),
    })
    .optional(),
});
export type ProjectSuggestion = z.infer<typeof projectSuggestionSchema>;
